import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredOrderCloseAtom = createMutationAtomFactory(
  'brokerage.brokeredOrderClose',
  (params: { id: string }) => ({
    tradeBrokeredOrderClose: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
